import request from '../request'

// MF-528 — Feature flags admin (School → Feature Flags). Flags are per-tenant.
// The BE takes the value as a query param and returns 204 (no body), so the caller
// updates the redux `tenant.featureFlag` optimistically after a successful call.
export const setFeatureFlag = (key, value, description) =>
  request.put(
    `/setting/feature-flag?${encodeURIComponent(key)}=${value ? 'true' : 'false'}`,
    description !== undefined ? { description } : undefined
  )

export const deleteFeatureFlag = (key) => request.delete(`/setting/feature-flag/${encodeURIComponent(key)}`)
